import React from "react";
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { motion } from "framer-motion";
import { FaStar } from "react-icons/fa";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./testimonial.css";

const testimonials = [
  {
    id: 1,
    name: "John Smith",
    rating: 5,
    review:
      "Thanks Delnaz for this beautiful short meditation. I have been little unwell since a few days and could actually feel the lump in the throat, the tightness in the chest and the anxiety but at the end of the meditation I felt somewhat relieved and fresh.",
  },
  {
    id: 2,
    name: "Emma Watson",
    rating: 4,
    review:
      "I thought I would share with you that journaling it helped me understand my own perspective of myself as a child.",
  },
  {
    id: 3,
    name: "David Lee",
    rating: 3,
    review:
      "Delnaaz, the prompts today helped me put in a flow bits and pieces of me as a child into a more complete picture. It was also just healing to acknowledge what made me feel safe and what didn't.",
  },
  {
    id: 4,
    name: "Sophia Brown",
    rating: 5,
    review:
      "Delnaaz, the prompts today helped me put in a flow bits and pieces of me as a child into a more complete picture. It was also just healing to acknowledge what made me feel safe and what didn't.",
  },
  {
    id: 5,
    name: "Michael",
    rating: 4,
    review:
      "I have been writing down my thoughts since long and it was all about my emotions, experiences based on given situations, but have never done it this way. Initially I thought I would simply be answering questions. However, gradually I am realising .. it .. is a way of connecting with myself.",
  },
  {
    id: 6,
    name: "Olivia",
    rating: 5,
    review:
      "I have been journaling off and on since many years. But, your prompts and meditation are making it seem so organic for my thoughts to flow and for me to pen what's brewing inside... I feel lighter everyday. Thank you Delnaz!",
  },
  {
    id: 7,
    name: "James",
    rating: 4,
    review:
      "It's really great reflection of ourselves to go down back into memories so deeply n to understand so many emotions n feelings those are deeply rooted/hidden as we never think so much abt ourselves..it's great practice to write down each emotions of past experiences and connect to it..I too have been doing this practice from past 3 yrs..it's wonderful ..thanks Dear Delnaz",
  },
  {
    id: 8,
    name: "Ava",
    rating: 5,
    review:
      "Delnaz your guidance and handholding has been really helpful & comforting",
  },
  {
    id: 9,
    name: "William",
    rating: 4,
    review:
      "This was so good. Never connected so deeply with self nor b so kind. Thank you Delu. Yr voice is so soothing. God bless",
  },
  {
    id: 10,
    name: "Isabella",
    rating: 5,
    review:
      "It was so wonderful going back to my younger version..felt deeply emotional..connecting realising what my younger version wanted from me ..I could not leave that younger version from my body n still holding it so tight..too much love I could pour and receive the same back",
  },
  {
    id: 11,
    name: "Benjamin",
    rating: 4,
    review:
      "Thank you Dearest Delnaz, I am so grateful for being a part of this group and going on this journey to know myself better, each promt and meditation was so beautiful and helpful in the healing. I have not completed it but will surely get back to it. Thanks so much for your time and efforts",
  },
  {
    id: 12,
    name: "Mia",
    rating: 5,
    review:
      "Thank you Delnaz..for the lovely efforts.. that you took to make our group soul very much ahead in life.. really very thankful and grateful to you..and Binny too.who added me in this amazing group AA",
  },
  {
    id: 13,
    name: "Ethan",
    rating: 4,
    review:
      "Dear Delnaz, I am so grateful for being a part of this process, each promt and meditation was so beautiful, thank you so much for your time and efforts to help us to heal",
  },
  {
    id: 14,
    name: "Charlotte",
    rating: 5,
    review:
      "Thanks Delnaz! An amazing journey! Greatly appreciate the time you have spent to do good for the society!",
  },
  {
    id: 15,
    name: "Alexander",
    rating: 4,
    review:
      "Thank you Delnaz for this journey of self discovery and self love. I always had the habit of penning down my thoughts and emotions. Your prompts helped me dig deeper into my soul. Along the way I also got the chance to meet so many beautiful, strong, resilient souls here, loved reading all the messages. Keep shining, keep healing",
  },
  {
    id: 16,
    name: "Amelia",
    rating: 5,
    review: "A huge gratitude to you my dear Delnaz for this initiative.",
  },
  {
    id: 17,
    name: "Daniel",
    rating: 4,
    review:
      "This was an amazing initiative helping us reflect on some pertinent issues.Please congratulations please keep on engaging with such exercises",
  },
  {
    id: 18,
    name: "Harper",
    rating: 5,
    review:
      "Thank you very much Delnaz for all your efforts and guidance.. haven't",
  },
  {
    id: 19,
    name: "Matthew",
    rating: 4,
    review:
      "Thank you so so much Delnaz. I have been with Delnaz and had several sessions with her. While it didn't only help me immensely in my own personal life, it also has helped me enormously with helping other people around.",
  },
  {
    id: 20,
    name: "Evelyn",
    rating: 5,
    review:
      "enjoying and understanding this journey. This challenge is well planned and well executed. Thanks for giving us so much of time. God Bless you always.",
  },
  {
    id: 21,
    name: "Joseph",
    rating: 4,
    review:
      "Delnaz, d world needs more people like you. Keep helping! keep healing! Shine out! God bless you in abundance!!! Immense gratitude to you.",
  },
  {
    id: 22,
    name: "Abigail",
    rating: 5,
    review:
      "Delnaaz, thanks for this journaling exercise. It has been Very well organized and very helpful. The videos and material you have shared are also excellent. I would",
  },
  {
    id: 23,
    name: "David",
    rating: 4,
    review:
      "Dear Delnaz, Thank you so much for this initiative. Being a part of this activity and this group has been such a blessing. ",
  },
  {
    id: 24,
    name: "Emily",
    rating: 5,
    review:
      "Thank you so much Delu! I have really felt so alive with these days that I have spent with the little nudge from you. Thank you again",
  },
  {
    id: 25,
    name: "Christopher",
    rating: 4,
    review:
      "Thank you so much Delnaz. For taking out so much of your time. For recording these soothing meditation for all of us and for these beautiful journaling prompts. Genuinely appreciate your efforts.",
  },
];

// Duplicate for demo
const data = [
  ...testimonials,
  ...testimonials,
  ...testimonials,
  ...testimonials,
];

const Testimonial = () => {
  return (
    <section className="testimonial-section py-5">
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-5"
        >
          <h6 className="section-subtitle">TESTIMONIALS</h6>

          <h2 className="section-title">What Our Clients Say</h2>

          <p className="section-desc">
            Testimonials of 30 day Journaling Challenge & Personal Sessions
          </p>
        </motion.div>

        <Swiper
          modules={[Autoplay, Navigation, Pagination]}
          loop={true}
          speed={1000}
          spaceBetween={25}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          navigation
          pagination={{
            clickable: true,
          }}
          breakpoints={{
            0: {
              slidesPerView: 1.2,
            },
            576: {
              slidesPerView: 1.5,
            },
            768: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 4,
            },
          }}
        >
          {data.map((item, index) => (
            <SwiperSlide key={index}>
              <motion.div
                whileHover={{
                  y: -8,
                  scale: 1.02,
                }}
                transition={{
                  duration: 0.3,
                }}
                className="testimonial-card"
              >
                {/* <img src={item.image} alt={item.name} className="client-img" /> */}

                <div className="stars">
                  {[...Array(5)].map((_, i) => (
                    <FaStar
                      key={i}
                      className={i < item.rating ? "star filled" : "star"}
                    />
                  ))}
                </div>

                <p className="review">"{item.review}"</p>

                {/* <h5>{item.name}</h5> */}

                <span>{/* {item.position} • {item.company} */}</span>
              </motion.div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </section>
  );
};

export default Testimonial;
